export const clearSessionAfterEdit=()=>{
  if (localStorage.getItem("UpdationMode") == "ON") {
      localStorage.removeItem("UpdationMode");
      localStorage.removeItem("displayBusinessName");
      localStorage.removeItem("agentName");
      localStorage.removeItem("agentGender");
      localStorage.removeItem("agentLanguageCode");
      localStorage.removeItem("agentLanguage");
      localStorage.removeItem("llmId");
      localStorage.removeItem("agent_id");
      localStorage.removeItem("knowledgeBaseId");
      localStorage.removeItem("agentRole");
      localStorage.removeItem("agentVoice");
      localStorage.removeItem("agentVoiceAccent");
      localStorage.removeItem("avatar");
      localStorage.removeItem("googleUrl");
      localStorage.removeItem("knowledge_base_id");
      localStorage.removeItem("knowledge_base_name");
      localStorage.removeItem("selectedAgentAvatar");
      localStorage.removeItem("webUrl");
      localStorage.removeItem("googleUrl");
      localStorage.removeItem("webUrl");
      localStorage.removeItem("aboutBusiness");
      localStorage.removeItem("additionalInstruction");
      localStorage.removeItem("knowledge_base_name");
      localStorage.removeItem("knowledge_base_id");
      localStorage.removeItem("bId");
      sessionStorage.removeItem("UpdationMode");
      sessionStorage.removeItem("agentName");
      sessionStorage.removeItem("agentGender");
      sessionStorage.removeItem("agentLanguageCode");
      sessionStorage.removeItem("agentLanguage");
      sessionStorage.removeItem("llmId");
      sessionStorage.removeItem("agent_id");
      sessionStorage.removeItem("knowledgeBaseId");
      sessionStorage.removeItem("googleListing");
      sessionStorage.removeItem("displayBusinessName");
      sessionStorage.removeItem("aboutBusinessForm");
      sessionStorage.removeItem("agentRole");
      sessionStorage.removeItem("agentVoice");
      sessionStorage.removeItem("agentVoiceAccent");
      sessionStorage.removeItem("avatar");
      sessionStorage.removeItem("businessDetails");
      sessionStorage.removeItem("businessId");
      sessionStorage.removeItem("businesServices");
      sessionStorage.removeItem("businessLocation");
      sessionStorage.removeItem("selectedCustomServices");
      sessionStorage.removeItem("bId");
      localStorage.removeItem("UpdationMode");
      localStorage.removeItem("UpdationModeStepWise");
      localStorage.removeItem("agentName");
      localStorage.removeItem("agentGender");
      localStorage.removeItem("agentLanguageCode");
      localStorage.removeItem("agentLanguage");
      localStorage.removeItem("llmId");
      localStorage.removeItem("agent_id");
      localStorage.removeItem("knowledgeBaseId");
      localStorage.removeItem("agentRole");
      localStorage.removeItem("agentVoice");
      localStorage.removeItem("agentVoiceAccent");
      localStorage.removeItem("avatar");
      localStorage.removeItem("googleUrl");
      localStorage.removeItem("webUrl");
      localStorage.removeItem("aboutBusiness");
      localStorage.removeItem("additionalInstruction");
      localStorage.removeItem("knowledge_base_name");
      localStorage.removeItem("knowledge_base_id");
      sessionStorage.removeItem("selectedfilterOption");
      sessionStorage.removeItem("placeDetailsExtract");
      sessionStorage.removeItem("agentNote");
      sessionStorage.removeItem("UpdationModeStepWise");
      sessionStorage.removeItem("prevAgentGender");
      sessionStorage.removeItem("prevAgentGender");
      sessionStorage.removeItem("UpdationModeStepWise");
      sessionStorage.removeItem("customServices");
      sessionStorage.removeItem("agentCode");
      sessionStorage.removeItem("businessUrl");
      sessionStorage.removeItem("selectedServices");
    }
}